import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CheckCircle, Heart, Home, Clock, Users } from 'lucide-react';
export function WhyEithanSection() {
  const features = [{
    title: 'Licensed & Insured',
    description: 'Total peace of mind — your home is always protected',
    icon: Shield
  }, {
    title: 'Free Estimates',
    description: 'Zero pressure — just honest, clear information',
    icon: CheckCircle
  }, {
    title: 'Full-Service Team',
    description: 'One call handles EVERYTHING — landscaping & junk removal',
    icon: Home
  }, {
    title: 'Local & Community-Based',
    description: 'We know your neighborhood and we care about it',
    icon: Heart
  }, {
    title: 'Consistent & Reliable',
    description: "We show up, every time, and deliver results you'll love",
    icon: Clock
  }, {
    title: 'Professional & Friendly',
    description: "A team you'll actually enjoy having at your home",
    icon: Users
  }];
  return <section className="py-24 bg-brand-offWhite" data-id="element-274">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-275">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-276">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-277">
            The EITHAN Difference
          </h2>
          <p className="text-xl text-brand-gold font-medium" data-id="element-278">
            Built On Trust & Pride
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 max-w-5xl mx-auto" data-id="element-279">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: index % 2 === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-5 items-start" data-id="element-280">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center text-brand-gold mt-1" data-id="element-281">
                  <Icon size={24} data-id="element-282" />
                </div>
                <div data-id="element-283">
                  <h3 className="text-xl font-bold text-brand-black mb-2 font-serif" data-id="element-284">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-285">{feature.description}</p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}